
export const GAME_LIST = [
    // Sports
    { label: "Cricket", value: "4", category: "sport" },
    { label: "Tennis", value: "2", category: "sport" },
    { label: "Football", value: "1", category: "sport" },
    { label: "Soccer", value: "1", category: "sport" },
    { label: "Horse Racing", value: "10", category: "sport" },
    { label: "Greyhound", value: "65", category: "sport" },
    { label: "Boxing", value: "6", category: "sport" },
    { label: "Motor Sport", value: "52", category: "sport" },
    { label: "Kabaddi", value: "66", category: "sport" },
    { label: "Table Tennis", value: "8", category: "sport" },
    { label: "Badminton", value: "22", category: "sport" },
    { label: "Darts", value: "57", category: "sport" },
    { label: "Basketball", value: "35", category: "sport" },
    { label: "Mixed Martial Arts", value: "3", category: "sport" },

    // Casino
    { label: "teen", value: "teen", category: "casino" },
    { label: "patti2", value: "patti2", category: "casino" },
    { label: "teen3", value: "teen3", category: "casino" },
    { label: "teen6", value: "teen6", category: "casino" },
    { label: "teen8", value: "teen8", category: "casino" },
    { label: "teen9", value: "teen9", category: "casino" },
    { label: "teen20", value: "teen20", category: "casino" },
    { label: "teen20b", value: "teen20b", category: "casino" },
    { label: "teen20c", value: "teen20c", category: "casino" },
    { label: "teenmuf", value: "teenmuf", category: "casino" },
    { label: "teen32", value: "teen32", category: "casino" },
    { label: "teen33", value: "teen33", category: "casino" },
    { label: "teen41", value: "teen41", category: "casino" },
    { label: "teen42", value: "teen42", category: "casino" },
    { label: "teen1", value: "teen1", category: "casino" },
    { label: "teen62", value: "teen62", category: "casino" },
    { label: "teensin", value: "teensin", category: "casino" },

    { label: "poker", value: "poker", category: "casino" },
    { label: "poker6", value: "poker6", category: "casino" },
    { label: "poker20", value: "poker20", category: "casino" },

    { label: "baccarat", value: "baccarat", category: "casino" },
    { label: "baccarat2", value: "baccarat2", category: "casino" },

    { label: "dt20", value: "dt20", category: "casino" },
    { label: "dt6", value: "dt6", category: "casino" },
    { label: "dt202", value: "dt202", category: "casino" },
    { label: "dtl20", value: "dtl20", category: "casino" },

    { label: "card32", value: "card32", category: "casino" },
    { label: "card32eu", value: "card32eu", category: "casino" },

    { label: "lucky5", value: "lucky5", category: "casino" },
    { label: "lucky7", value: "lucky7", category: "casino" },
    { label: "lucky15", value: "lucky15", category: "casino" },
    { label: "lucky7eu", value: "lucky7eu", category: "casino" },
    { label: "lucky7eu2", value: "lucky7eu2", category: "casino" },

    { label: "ourroullete", value: "ourroullete", category: "casino" },
    { label: "roulette13", value: "roulette13", category: "casino" },

    { label: "goal", value: "goal", category: "casino" },

    { label: "superOver", value: "superOver", category: "casino" },
    { label: "superOver2", value: "superOver2", category: "casino" },
    { label: "superOver3", value: "superOver3", category: "casino" },

    { label: "dum10", value: "dum10", category: "casino" },

    { label: "race2", value: "race2", category: "casino" },
    { label: "race20", value: "race20", category: "casino" },
    { label: "race17", value: "race17", category: "casino" },

    { label: "aaa2", value: "aaa2", category: "casino" },

    { label: "notenum", value: "notenum", category: "casino" },
    { label: "trio", value: "trio", category: "casino" },
    { label: "trap", value: "trap", category: "casino" },

    { label: "sicbo", value: "sicbo", category: "casino" },
    { label: "sicbo2", value: "sicbo2", category: "casino" },

    { label: "kbc", value: "kbc", category: "casino" },
    { label: "queen", value: "queen", category: "casino" },
    { label: "lottcard", value: "lottcard", category: "casino" },

    { label: "ballbyball", value: "ballbyball", category: "casino" },
    { label: "mogambo", value: "mogambo", category: "casino" },
    { label: "dolidana", value: "dolidana", category: "casino" },

    { label: "poison", value: "poison", category: "casino" },
    { label: "poison20", value: "poison20", category: "casino" },

    { label: "joker20", value: "joker20", category: "casino" },
];

export const getGameCategory = (value) => {
    const game = GAME_LIST.find(g => g.value === value);
    return game ? game.category : null;
};
